"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakTextActionHandler = exports.SpeakTextActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
class SpeakTextActionArgs {
    constructor(text, color, size) {
        this.text = text;
        this.color = color;
        this.size = size;
        this.__type = ActionType_1.ActionType.SpeakText;
        this.__typeName = "SpeakText";
    }
}
exports.SpeakTextActionArgs = SpeakTextActionArgs;
let SpeakTextActionHandler = class SpeakTextActionHandler {
    activate(sequence, container, action) {
        const { text, color, size } = action.args;
        container.applyFloatingText(sequence, action.actorId, text, color, size, "slow");
        container.applyBattleLogText(sequence, action.actorId, text, color);
    }
};
SpeakTextActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.SpeakText)
], SpeakTextActionHandler);
exports.SpeakTextActionHandler = SpeakTextActionHandler;
